import { useState } from 'react';
import { AuthLayout, ButtonBlockPrimary, FormGroup, InputTextIcon } from '../../components';
import { useLocation, useNavigate } from 'react-router-dom';
import { showMessage } from '../../utls/message';
import { resetPassword } from '../../service/authService';



const ResetPassword = () => {
    const location = useLocation()
    const { otp } = location.state;
    const [password, setPassword] = useState("");
    const [confrmPassword, setConfrmPassword] = useState("");
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState<boolean>(false);

    const onSubmit = async () => {
        if (password.length > 0 && confrmPassword === password) {
            const data = {
                otp: otp,
                password: confrmPassword
            };

            const response = await resetPassword(data)
            if (response.code === 200) {
                navigate(`/auth`)
            } else {
                showMessage('Gagal melakuakan reset password', 'error')
            }
        } else {
            showMessage('Password dan Konfirmasi Password \nTidak Sesuai', 'error')
        }


    }
    return (
        <AuthLayout title='New Password'>
            <div className='py-4'>
                <div className="w-full flex justify-center mt-16">
                    <img src="/assets/imgs/icon-password.png" alt="" />
                </div>
                <FormGroup label={'Password'}>
                    <InputTextIcon
                        placeholder='Password'
                        type={!showPassword ? 'password' : 'text'}
                        icon={!showPassword ? 'FaEyeSlash' : 'FaEye'}
                        value={password}
                        onChange={(e) => { setPassword(e.target.value) }}
                        onClick={() => { setShowPassword(!showPassword) }} />
                </FormGroup>
                <FormGroup label={'Konfirmasi Password'}>
                    <InputTextIcon
                        placeholder='Password'
                        type={!showPassword ? 'password' : 'text'}
                        icon={!showPassword ? 'FaEyeSlash' : 'FaEye'}
                        value={confrmPassword}
                        onChange={(e) => { setConfrmPassword(e.target.value) }}
                        onClick={() => { setShowPassword(!showPassword) }} />
                </FormGroup>
                <div className='my-4'>
                    <ButtonBlockPrimary
                        onClick={() => { onSubmit() }}
                        label='Reset Password' />
                </div>
            </div>
        </AuthLayout>
    );
};

export default ResetPassword;